import { render, staticRenderFns } from "./FacebookProvider.vue?vue&type=template&id=f82838f6&scoped=true&"
import script from "./FacebookProvider.vue?vue&type=script&lang=js&"
export * from "./FacebookProvider.vue?vue&type=script&lang=js&"
import style0 from "./FacebookProvider.vue?vue&type=style&index=0&id=f82838f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82838f6",
  null
  
)

export default component.exports